export const galleryData = {
  "1": [
    "/images/gallery/1/IMG_9815.jpg",
    "/images/gallery/1/IMG_9816.jpg",
    "/images/gallery/1/IMG_9817.jpg",
    "/images/gallery/1/IMG_9818.jpg",
    "/images/gallery/1/IMG_9819.jpg",
    "/images/gallery/1/IMG_9821.jpg",
    "/images/gallery/1/IMG_9824.jpg"
  ],
  "2": [
    "/images/gallery/2/IMG_9785.jpg",
    "/images/gallery/2/IMG_9786.jpg",
    "/images/gallery/2/IMG_9787.jpg",
    "/images/gallery/2/IMG_9790.jpg",
    "/images/gallery/2/IMG_9791.jpg",
    "/images/gallery/2/IMG_9792.jpg",
    "/images/gallery/2/IMG_9793.jpg",
    "/images/gallery/2/IMG_9794.jpg",
    "/images/gallery/2/IMG_9796.jpg",
    "/images/gallery/2/IMG_9798.jpg",
    "/images/gallery/2/IMG_9799.jpg",
    "/images/gallery/2/IMG_9802.jpg",
    "/images/gallery/2/IMG_9806.jpg"
  ],
  "3": [
    "/images/gallery/3/IMG_9714.jpg",
    "/images/gallery/3/IMG_9715.jpg",
    "/images/gallery/3/IMG_9716.jpg",
    "/images/gallery/3/IMG_9720.jpg",
    "/images/gallery/3/IMG_9721.jpg",
    "/images/gallery/3/IMG_9722.jpg",
    "/images/gallery/3/IMG_9725.jpg",
    "/images/gallery/3/IMG_9731.jpg",
    "/images/gallery/3/IMG_9741.jpg",
    "/images/gallery/3/IMG_9742.jpg",
    "/images/gallery/3/IMG_9744.jpg",
    "/images/gallery/3/IMG_9747.jpg",
    "/images/gallery/3/IMG_9748.jpg",
    "/images/gallery/3/IMG_9749.jpg",
    "/images/gallery/3/IMG_9751.jpg",
    "/images/gallery/3/IMG_9753.jpg",
    "/images/gallery/3/IMG_9756.jpg"
  ],
  "4": [
    "/images/gallery/4/IMG_9760.jpg",
    "/images/gallery/4/IMG_9761.jpg",
    "/images/gallery/4/IMG_9765.jpg",
    "/images/gallery/4/IMG_9767.jpg",
    "/images/gallery/4/IMG_9770.jpg",
    "/images/gallery/4/IMG_9772.jpg",
    "/images/gallery/4/IMG_9774.jpg",
    "/images/gallery/4/IMG_9777.jpg",
    "/images/gallery/4/IMG_9779.jpg",
    "/images/gallery/4/IMG_9780.jpg",
    "/images/gallery/4/IMG_9781.jpg",
    "/images/gallery/4/IMG_9784.jpg"
  ],
  "root": [
    "/images/gallery/IMG_9456.jpg",
    "/images/gallery/IMG_9457.jpg",
    "/images/gallery/IMG_9459.jpg",
    "/images/gallery/IMG_9462.jpg",
    "/images/gallery/IMG_9463.jpg",
    "/images/gallery/IMG_9464.jpg",
    "/images/gallery/IMG_9465-2.jpg",
    "/images/gallery/IMG_9466.jpg"
  ],
  "prizemlje": [
    "/images/gallery/prizemlje/IMG_9825.jpg",
    "/images/gallery/prizemlje/IMG_9826.jpg",
    "/images/gallery/prizemlje/IMG_9827.jpg",
    "/images/gallery/prizemlje/IMG_9829.jpg",
    "/images/gallery/prizemlje/IMG_9831.jpg",
    "/images/gallery/prizemlje/IMG_9833.jpg",
    "/images/gallery/prizemlje/IMG_9837.jpg",
    "/images/gallery/prizemlje/IMG_9838.jpg",
    "/images/gallery/prizemlje/IMG_9839.jpg",
    "/images/gallery/prizemlje/IMG_9840.jpg",
    "/images/gallery/prizemlje/IMG_9844.jpg",
    "/images/gallery/prizemlje/IMG_9847.jpg",
    "/images/gallery/prizemlje/IMG_9849.jpg",
    "/images/gallery/prizemlje/IMG_9851.jpg",
    "/images/gallery/prizemlje/IMG_9852.jpg",
    "/images/gallery/prizemlje/IMG_9854.jpg",
    "/images/gallery/prizemlje/IMG_9855.jpg"
  ]
};
